



































































































































import {
	CatalogueItemModel,
	QueryOperator,
	WorkTaskBasicModel,
	WorkTaskRuleModel,
	WorkTaskStatementModel
} from '@/libs/Api';
import Page from '@/Page.vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { catalogueItemsStore } from '@/libs/catalogue-items/+state/store';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { Guid } from '@/libs/common/functions/guid';
import { workTaskStatementsStore } from '@/libs/work-task-statements/+state/store';
import { cloneDeep, isEqual } from 'lodash';
import moment from 'moment';
import ApiService from "@/libs/core/api-service";

@Component({})
export default class StatementDetailDialog extends Page {

    dialog = false;
    valid = false;
    saving = false;
    item: WorkTaskStatementModel | null = null;
    itemOriginal: WorkTaskStatementModel | null = null;
    id: string | null = null;
    editableState = false;
    newId = Guid.EmptyGuid();
    basicRules = [
        (v: any) => !!v || this.translate('validation.thisFieldIsRequired')
    ];
    changed = false;
    deleteDialog = false;
    unsavedDialog = false;
    deleting = false;
	checkedPeriod = false;
	isPeriodLocked = false;
    catalogueItem: CatalogueItemModel | null = null;
    
    get isNew (): boolean {
        return this.id == Guid.EmptyGuid();
    }

    get isReadonly (): boolean {
        return !this.item?.workTask?.partyWorkDay?.partyId;
    }
    
    get today(): string {
        return moment().format("YYYY-MM-DDT23:59:59");
    }

    @Prop() partyId!: string | null;
    @Prop({ default: null }) districtId!: string | null;
    @Prop({ default: true }) canChangeParty!: boolean;

    @Ref() form!: any;

    @Watch("item", { immediate: true, deep: true })
    itemChanged(v: WorkTaskStatementModel | null) {
        if (v && this.itemOriginal && v.id !== Guid.EmptyGuid()) {
            let original = cloneDeep(this.itemOriginal);
            if (original.workTask) {
                original.workTask.time = moment(original.workTask.time).format("YYYY-MM-DD");
            }
            let newItem = cloneDeep(v);
            if (newItem.workTask) {
                newItem.workTask.time = moment(newItem.workTask.time).format("YYYY-MM-DD");
            }

            this.changed = !isEqual(newItem, original);
        }
    }
    
    open (id: string) {
        this.dialog = true;
        this.changed = false;
        this.id = id;
        workTaskStatementsStore.dispatch(CrudAction.Get, { id: id });
        this.editableState = true;
        this.subscribe(workTaskStatementsStore, CrudReponse.Get).then((e: WorkTaskStatementModel) => {
			this.checkedPeriod = true;
            this.item = e;
            this.itemOriginal = cloneDeep(e);
			this.isPeriodLocked = e.workTask?.partyPeriod?.isLocked == true;
            this.catalogueItem = this.item.workTask!.catalogueItem!;
        });
    }

    create () {
        this.dialog = true;
        this.id = Guid.EmptyGuid();
        this.item = {
            id: Guid.EmptyGuid(),
            amount: undefined,
            userId: undefined,
            visitNumber: 1,
            workTask: {
                id: Guid.EmptyGuid(),
                partyWorkDayId: Guid.EmptyGuid(),
                isProvided: true,
                time: undefined,
                partyWorkDay: {
                    id: Guid.EmptyGuid(),
                    partyId: this.partyId,
					isUserDefined: true
                },
				isUserDefined: true
            } as WorkTaskBasicModel
        } as WorkTaskStatementModel;
        this.itemOriginal = cloneDeep(this.item);
        this.changed = true;
		this.checkedPeriod = false;
    }

    deleteItemClick () {
        this.deleteDialog = true;
    }

    deleteItem () {
        workTaskStatementsStore.dispatch(CrudAction.Delete, createCrudQueryPayload<WorkTaskStatementModel>(undefined, [
            { field: "id", op: "eq", comparand: this.id! }
        ]));
        this.deleting = true;
        this.subscribe(workTaskStatementsStore, CrudReponse.Delete).then(() => {
            this.dialog = false;
            this.$emit("change");
            this.deleteDialog = false;
            this.deleting = false;
        }).catch(() => {
            this.deleting = false;
        });
    }

    save () {
        if (this.form.validate()) {
            if (this.item?.id == Guid.EmptyGuid()) {
                workTaskStatementsStore.dispatch(CrudAction.Create, { item: this.item });
                this.saving = true;
                this.subscribe(workTaskStatementsStore, CrudReponse.Create).then(() => {
                    this.saving = false;
                    this.dialog = false;
                    this.$emit("change");
                }).catch(() => {
                    this.saving = false;
                });
            }
            else {
                this.item!.price = this.item!.workTask!.unitPrice! * this.item!.amount!
                workTaskStatementsStore.dispatch(CrudAction.Update, { item: this.item });
                this.saving = true;
                this.subscribe(workTaskStatementsStore, CrudReponse.Update).then(() => {
                    this.saving = false;
                    this.dialog = false;
                    this.$emit("change");
                }).catch(() => {
                    this.saving = false;
                });
            }
        }
    }

    close () {
        if (!this.changed)
            this.dialog = false;
        else 
            this.unsavedDialog = true;
    }

    catalogueItemIdChanged (id: string | null) {
        const catalogueItems = catalogueItemsStore.useGetter(CrudGetter.Data) as Array<CatalogueItemModel>;
        const catalogueItem = catalogueItems.firstOrDefault(x => x.id == id);
        if (catalogueItem != null) {
            this.item!.workTask!.catalogueItem = catalogueItem
        }
        this.catalogueItem = catalogueItem;
    }

	isLockedByBilling() {
		return this.item?.billing?.isLocked == true;
	}

	filtersChanged() {
		this.checkedPeriod = false;
		if (this.item!.workTask!.partyWorkDay!.partyId && this.item!.workTask!.time) {
			this.checkPeriod();
		}
	}

	checkPeriod() {
		ApiService.api.getPartyPeriodBatch(1, 1, {
			predicates: [
				{ field: "partyId", op: QueryOperator.Eq, comparand: this.item!.workTask!.partyWorkDay!.partyId },
				{ field: "fromDate", op: QueryOperator.Lte, comparand: this.item!.workTask!.time },
				{ field: "toDate", op: QueryOperator.Gte, comparand: this.item!.workTask!.time }
			],
			orderby: []
		}).then((x: any) => {
			this.checkedPeriod = true;
			this.isPeriodLocked = x.data.returnValue.items?.firstOrDefault()?.isLocked ?? false;
		})
	}

}
